<template>
  <div>
    <u-modal id="createApiPing" link="Добавить" title="Добавить" :isModalOpen="isModalOpen" @isModalOpen="isModalOpen = $event">
      <ApiPingCreate @created="handleCreated"/>
    </u-modal>
    <button type="submit" class="btn btn-primary mb-2" @click="isModalOpen=true">Добавить</button>

    <div v-if="apiPing.length === 0" class="text-center p-4">
      <p class="text-muted">Пусто</p>
    </div>

    <div v-else>
      <table class="table">
        <thead>
        <tr>
          <th scope="col">ID</th>
          <th scope="col">URL</th>
          <th scope="col">Действие</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(row, index) in apiPing" :key="index">
          <th scope="row">{{ row.id }}</th>
          <td>{{ row.url }}</td>
          <td>
            <button
                @click="deleteItem(row.id)"
                class="btn btn-link text-danger p-0"
            >
              Удалить
            </button>
          </td>
        </tr>
        </tbody>
      </table>

      <!-- Пагинация -->
      <nav v-if="pagination.totalPages > 1" aria-label="Пагинация">
        <ul class="pagination justify-content-center">
          <li class="page-item" :class="{ disabled: pagination.page === 1 }">
            <button class="page-link" @click="changePage(pagination.page - 1)" :disabled="pagination.page === 1">
              Предыдущая
            </button>
          </li>

          <template v-for="pageNum in visiblePages" :key="pageNum">
            <li v-if="pageNum === '...'" class="page-item disabled">
              <span class="page-link">...</span>
            </li>
            <li v-else class="page-item" :class="{ active: pageNum === pagination.page }">
              <button class="page-link" @click="changePage(pageNum)">
                {{ pageNum }}
              </button>
            </li>
          </template>

          <li class="page-item" :class="{ disabled: pagination.page === pagination.totalPages }">
            <button class="page-link" @click="changePage(pagination.page + 1)" :disabled="pagination.page === pagination.totalPages">
              Следующая
            </button>
          </li>
        </ul>

        <div class="text-center text-muted small">
          Страница {{ pagination.page }} из {{ pagination.totalPages }} (Всего: {{ pagination.total }})
        </div>
      </nav>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, onMounted, watch } from "vue";
import { useApiPingStore } from '@/store/api-ping'
import ApiPingCreate from "@/views/api_ping/ApiPingCreate.vue";

const isModalOpen = ref(false);
const apiPingStore = useApiPingStore();
const currentPage = ref(1);

// Компьютированные свойства для данных и пагинации
const apiPing = computed(() => apiPingStore.items.data || []);
const pagination = computed(() => apiPingStore.items.pagination || {
  page: 1,
  limit: 10,
  total: 0,
  totalPages: 0
});

// Получение видимых страниц для пагинации
const visiblePages = computed(() => {
  const total = pagination.value.totalPages;
  const current = pagination.value.page;
  const pages = [];

  if (total <= 7) {
    for (let i = 1; i <= total; i++) pages.push(i);
  } else {
    if (current <= 4) {
      for (let i = 1; i <= 5; i++) pages.push(i);
      pages.push('...');
      pages.push(total);
    } else if (current >= total - 3) {
      pages.push(1);
      pages.push('...');
      for (let i = total - 4; i <= total; i++) pages.push(i);
    } else {
      pages.push(1);
      pages.push('...');
      for (let i = current - 1; i <= current + 1; i++) pages.push(i);
      pages.push('...');
      pages.push(total);
    }
  }

  return pages;
});

// Загрузка данных при изменении страницы
watch(currentPage, () => {
  loadData();
});

// Загрузка данных
const loadData = () => {
  apiPingStore.getList(currentPage.value);
};

// Смена страницы
const changePage = (page) => {
  if (page < 1 || page > pagination.value.totalPages || page === '...') return;
  currentPage.value = page;
};

// Обработчик создания нового элемента
const handleCreated = () => {
  isModalOpen.value = false;
  loadData(); // Перезагружаем данные
};

// Удаление элемента
const deleteItem = async (id) => {
  if (confirm('Вы уверены, что хотите удалить этот элемент?')) {
    try {
      await apiPingStore.delete(id);
      loadData(); // Перезагружаем данные
    } catch (error) {
      console.error('Ошибка при удалении:', error);
    }
  }
};

// Загрузка данных при монтировании компонента
onMounted(() => {
  loadData();
});
</script>